// extracted by mini-css-extract-plugin
export default {"wrapper":"Project_wrapper__Y6j4q"};